import lang from "../../lib/appfuse-react/core/lang";
import newborns from "../caseInfo/newborns";

const noReportListService = [{
    matcher: 'noReport',
    reply: config => {
        if(config.method==='post') {
            return [200, newborns[0]];
        } else {
            let data = newborns.filter(newborn => lang.isNotEmpty(newborn.receiveUidDate));
            data = data.filter(newborn => lang.isEmpty(newborn.reportDate));
            data = data.filter(newborn => {
                const addZero = (str) => str<10? '0' + str : str;
                let now = new Date();
                now.setDate(now.getDate()-7);
                const year = now.getFullYear();
                const month = addZero(now.getMonth()+1);
                const date = addZero(now.getDate());
                const time = `${year}/${month}/${date}`;
                return time > newborn.receiveUidDate;
            });
            return [200, data];
        }
    }
}, {
    matcher: /noReport\/(.*)/,
    reply: config => {
        const id = /noReport\/(.*)/.exec(config.url)[1];
        const newborn = newborns.find(newborn => newborn.no === id);
        return [200, newborn];
    }
}];

export default noReportListService;